"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Select = void 0;

var _react = _interopRequireDefault(require("react"));

var _ = require("../..");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Select = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var className = props.className,
      describedBy = props['aria-describedby'],
      errorMessage = props.errorMessage,
      formGroup = props.formGroup,
      hint = props.hint,
      id = props.id,
      items = props.items,
      label = props.label,
      attributes = _objectWithoutProperties(props, ["className", "aria-describedby", "errorMessage", "formGroup", "hint", "id", "items", "label"]);

  var describedByValue = describedBy || '';
  var hintComponent;
  var errorMessageComponent;

  if (hint) {
    var hintId = "".concat(id, "-hint");
    describedByValue += " ".concat(hintId);
    hintComponent = /*#__PURE__*/_react["default"].createElement(_.Hint, _extends({}, hint, {
      id: hintId
    }));
  }

  if (errorMessage) {
    var errorId = id ? "".concat(id, "-error") : '';
    describedByValue += " ".concat(errorId);
    errorMessageComponent = /*#__PURE__*/_react["default"].createElement(_.ErrorMessage, _extends({}, errorMessage, {
      id: errorId
    }));
  }

  var options = items.map(function (option, index) {
    var reactListKey = option.reactListKey,
        children = option.children,
        optionAttributes = _objectWithoutProperties(option, ["reactListKey", "children"]);

    return /*#__PURE__*/_react["default"].createElement("option", _extends({}, optionAttributes, {
      key: reactListKey || index
    }), children);
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "govuk-form-group".concat(errorMessage ? ' govuk-form-group--error' : '', " ").concat((formGroup === null || formGroup === void 0 ? void 0 : formGroup.className) || '')
  }, /*#__PURE__*/_react["default"].createElement(_.Label, _extends({}, label, {
    htmlFor: id
  })), hintComponent, errorMessageComponent, /*#__PURE__*/_react["default"].createElement("select", _extends({
    className: "govuk-select ".concat(className || '').concat(errorMessage ? ' govuk-select--error' : ''),
    id: id,
    ref: ref,
    "aria-describedby": describedByValue || null
  }, attributes), options));
});

exports.Select = Select;
Select.displayName = 'Select';